// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  
  firebaseConfig : {
    apiKey: "AIzaSyBTD5uBUImi-Zt7mi8JvgvakQsXhNY_GJQ",
    authDomain: "daymart-aac3e.firebaseapp.com",
    databaseURL: "https://daymart-aac3e-default-rtdb.firebaseio.com",
    projectId: "daymart-aac3e",
    storageBucket: "daymart-aac3e.appspot.com",
    messagingSenderId: "177568239302",
    appId: "1:177568239302:web:82287c2162cd1189c2d1c7",
    measurementId: "G-YCZE1MP1XR"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
